import * as React from "react";
import { addBranch } from "services/branchService";
import { toast } from "react-toastify";
import { Button } from "@progress/kendo-react-buttons";
import BranchesList from "./brancheslist";
import styles from "../Settings.module.scss";
import EditBranch from "./Editbranch";

const Branches = (props) => {
  const [showAddNewBranchForm, setShowAddNewBranchForm] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const closeform = () => {
    setShowAddNewBranchForm(false);
  };

  React.useEffect(() => {
    if (props.onClose === false) {
      closeform();
    }
  }, [props.onClose]);

  const handleSubmitNewBranch = async (e) => {
    setIsSubmitting(true);
    try {
      const result = await addBranch(e);
      if (result.success) {
        toast.success("Branch Added Successfully");
        setShowAddNewBranchForm(false);
      } else {
        toast.error("Failed to add branch");
      }
    } catch (error) {
      toast.error("An error occurred while adding branch");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <React.Fragment>
      <>
        <div className="row">
          <div className="col-lg-10 col-md-8"></div>
          <Button
            className={`common-btn col-lg-1 col-md-4 p-2 mt-5 ${
              styles[`button`]
            }`}
            onClick={() => {
              setShowAddNewBranchForm(true);
              props.open();
            }}
          >
            Add <br></br>
            Branch
          </Button>
        </div>

        <div className="settings-grid-wrapper">
          <BranchesList />
        </div>
      </>
      {showAddNewBranchForm && (
        <EditBranch
          cancelEdit={closeform}
          onSubmit={handleSubmitNewBranch}
          type="addNew"
          isSubmitting={isSubmitting}
        />
      )}
    </React.Fragment>
  );
};

export default Branches;
